import React, { useEffect, useRef, useState } from "react";
import { ReactComponent as Ham } from "../../../img/NavBar/Ham.svg";
import { ReactComponent as Left } from "../../../img/Section/Arrow - Left.svg";
import { ReactComponent as User } from "../../../img/NavBar/User.svg";
import { NavLink, useHistory } from "react-router-dom";
import { Container, DropDown } from "../../../utils/CustomComponents";
import gsap from "gsap";
import OnOutsiceClick from "react-outclick";
import { useUser } from "../../../utils/Contexts/Context";
function NavBar({ AsideRef }) {
    const nav_bar = useRef();
    const logo = useRef();
    const nav = useRef();
    const ham = useRef();
    const nav_wrapper = useRef();
    const {
        user: {
            other_data: { language: lang },
        },
    } = useUser();
    const [language, setLanguge] = useState(lang);
    const history = useHistory();
    useEffect(() => {
        const tl = gsap.timeline();
        tl.from(logo.current, { opacity: 0, scale: 0.6 }).from(nav.current.children, {
            opacity: 0,
            y: -10,
            stagger: { each: 0.125 },
            duration: 0.5,
        });
        // This controlls the navbar state, (wether scrolled or not)
        window.addEventListener("scroll", () => {
            window.scrollY > 60
                ? nav_bar.current && nav_bar.current.classList.add("scrolled")
                : nav_bar.current && nav_bar.current.classList.remove("scrolled");
        });
    }, []);
    useEffect(() => {
        ham.current.onclick = () => {
            nav_wrapper.current.classList.toggle("open");
            ham.current.classList.toggle("open");
        };
        nav.current.onclick = () => {
            nav_wrapper.current.classList.remove("open");
            ham.current.classList.remove("open");
        };
    }, []);

    function setLanguage(Language) {
        // send chosen language to API to set it
        setLanguge(Language);
        return null;
    }
    return (
        <div id="dash_nav_wrapper">
            <div id="dash_nav" ref={nav_bar}>
                <Container>
                    <OnOutsiceClick
                        onOutsideClick={() => {
                            nav_wrapper.current && nav_wrapper.current.classList.remove("open");
                            ham.current && ham.current.classList.remove("open");
                        }}
                    >
                        <div className="nav_bar_wrapper">
                            <div
                                className="aside_toggle_mobile"
                                onClick={() => {
                                    AsideRef && AsideRef.current.classList.add("open");
                                }}
                            >
                                <div className="hamburger">
                                    <Ham />
                                </div>
                            </div>
                            <div className="logo" ref={logo}>
                                <NavLink
                                    to="/"
                                    onClick={(e) => {
                                        e.preventDefault();

                                        window.location.pathname === "/dashboard"
                                            ? history.push("/")
                                            : history.goBack();
                                    }}
                                >
                                    <Left />
                                    <p>Go Back</p>
                                </NavLink>
                            </div>
                            <NavItems nav_wrapper={nav_wrapper} navRef={nav}>
                                <NavItem text="home" url="" />
                                <span className="bar"></span>
                                <DropDown
                                    header="Language"
                                    initialOption={language}
                                    placeHolder={language}
                                    dropListArray={[{ render: "en" }]}
                                    setOption={setLanguage}
                                    width="auto"
                                />
                                <NavItem
                                    text="John"
                                    url=""
                                    sufIcon={<User fill="#16202a" width={18} />}
                                />
                            </NavItems>
                            {/* Hamburger that shows only on mobile */}
                            <div className="hamburger">
                                <Ham ref={ham} />
                            </div>
                        </div>
                    </OnOutsiceClick>
                </Container>
            </div>
        </div>
    );
}

export default NavBar;

function NavItems({ children, navRef, className, nav_wrapper }) {
    return (
        <nav className={className} ref={nav_wrapper}>
            <ul ref={navRef}>{children}</ul>
        </nav>
    );
}

function NavItem({ text = "", url = "", sufIcon, className }) {
    return (
        <NavLink to={`/${url}`} activeClassName="active" className={className} exact={url === ""}>
            {sufIcon}
            {text}
        </NavLink>
    );
}
